// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2196":"bf3b217b7955ee0e","2888":"91e5a2230ee60094"}[chunkId] + ".css";
};